import { Fragment } from "@wordpress/element";

import { AdditionalOptions } from "~buildable/utils/enums";
import BlockGeneralOptions from "~buildable/utils/block-general-options";
import BlockVisibilityOptions from "~buildable/utils/block-visibility-options";

const AdditionalOptionsComponents = {
  [AdditionalOptions.GENERAL]: BlockGeneralOptions,
  [AdditionalOptions.VISIBILITY]: BlockVisibilityOptions
};

const getBlockAdditionalOptions = (props, excludeOptions = null) => {
  let optionsArray = Object.values(AdditionalOptions);
  if (excludeOptions !== null) {
    if (Array.isArray(excludeOptions)) {
      optionsArray = optionsArray.filter((option) => excludeOptions.indexOf(option) === -1);
    } else {
      throw "'excludeOptions' passed to getBlockAdditionalOptions method must be an Array.";
    }
  }

  return (
    <Fragment>
      { optionsArray.map((option) => {
        const AdditionalOptionsComponent = AdditionalOptionsComponents[option];
        return (
          <AdditionalOptionsComponent
            key={ option }
            blockAttributes={ props.attributes }
            setAttributes={ props.setAttributes }
          />
        )
      })}
    </Fragment>
  )
}

export default getBlockAdditionalOptions;
